import { render, staticRenderFns } from "./videoDati.vue?vue&type=template&id=24ad44b6&scoped=true&"
import script from "./videoDati.vue?vue&type=script&lang=js&"
export * from "./videoDati.vue?vue&type=script&lang=js&"
import style0 from "./videoDati.vue?vue&type=style&index=0&id=24ad44b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad44b6",
  null
  
)

export default component.exports